import React, { useEffect, useState } from 'react';

import api from '~/services/api';

import { Bpmn } from '.';
import FlowSubtitle from './FlowSubtitle';
import { Container } from './styles';

const BpmnAdapter = ({ processInstanceId }: any) => {
  const [data, setData] = useState('');

  useEffect(() => {
    if (processInstanceId) {
      api
        .get(`/processes-definition/process-instance/${processInstanceId}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e);
        });
    }
  }, [processInstanceId]);

  return (
    <Container>
      <Bpmn data={data} />
      <FlowSubtitle />
    </Container>
  );
};

export default BpmnAdapter;
